/**
 * There is some content in the shop, where we constantly need to update the date manually
 * within certain intervals.
 *
 * For example, there is legal text in the footer(p.1), where the date of the ABDA-Datenbank,
 * must be updated every 2 weeks. There are also some legal texts or vouchers, where the date
 * must be updated once per year.
 *
 * The script allowes to change the date according to the interval, set in the date wrapper as HTML
 * attribute: <div data-date-placeholder="two-weeks"></div>
 *
 * It compares the current date (day) and changes it to the date in the past, according to
 * the provided interval. For example:
 * if the attribute value === "two-weeks", the script will set the new date the following way:
 * if the current date is 02.02.2023 => the new date will be 01.02.2023;
 * 15.02.2022 => 01.02.2022;
 * 16.12.2023 => 15.12.2023 etc.
 *
 * There is an option "one-year" to change the year in the date.
 * @param {string} frequence "two-weeks"|"one-year"
 */
const changeDateOnFrequence = frequence => {
  const now = new Date()
  switch (frequence) {
    case 'two-weeks':
      if (now.getDate() > 15) {
        return `15.${('0' + (now.getMonth() + 1)).slice(
          -2
        )}.${now.getFullYear()}`
      } else {
        return `01.${('0' + (now.getMonth() + 1)).slice(
          -2
        )}.${now.getFullYear()}`
      }

    case 'one-year':
      return now.getFullYear()
  }
}

const calculateDate = elements => {
  if (elements.length > 0) {
    elements.forEach(elem => {
      const frequence = elem.getAttribute('data-date-placeholder')

      if (frequence) {
        elem.innerHTML = frequence ? changeDateOnFrequence(frequence) : ''
      }
    })
  }
}

export default () => {
  window.addEventListener('DOMContentLoaded', event => {
    var iframe = event.target.getElementById('legalText')

    if (iframe) {
      const footerDatePlaceholders =
        iframe.contentWindow.document.querySelectorAll(
          '[data-date-placeholder]'
        )
      calculateDate(footerDatePlaceholders)
    }

    const otherPlaceholders = event.target.querySelectorAll(
      '[data-date-placeholder]'
    )

    if (otherPlaceholders) {
      calculateDate(otherPlaceholders)
    }
  })
}
